import React from 'react';
var StaticInfoPage = function (_a) {
    var title = _a.title, titleClassName = _a.titleClassName, updatedAt = _a.updatedAt, introduction = _a.introduction, beforeSections = _a.beforeSections, sectionsId = _a.sectionsId, sections = _a.sections, afterSections = _a.afterSections;
    return (React.createElement("div", { className: "main-content" },
        React.createElement("h1", { className: titleClassName }, title),
        updatedAt && (React.createElement("p", null,
            React.createElement("small", { className: "centered" },
                "Sist oppdatert: ",
                React.createElement("em", null, updatedAt)))),
        introduction,
        beforeSections,
        React.createElement("ol", { id: sectionsId, className: "faq" }, sections.map(function (section) { return (React.createElement("li", { id: section.id, className: "object", key: section.id },
            React.createElement("h2", null, section.title),
            React.createElement("div", null, section.body))); })),
        afterSections));
};
export default StaticInfoPage;
